// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 380;
export const appSidebarWidth = 320;

export const LOAD_MESSAGES_COUNT = 20;
export const LOAD_MORE_MESSAGES_COUNT = 100;

export const noWhatsappErr = 'No phone number WhatsApp account';
